<template>
	<div>
		<el-form inline="">
			<el-form-item label="添加时间">
				<el-date-picker type="daterange" v-model="query.time" @change="getList()" size="small"
					value-format="yyyy-MM-dd" style="width: 320px;">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="query.status" @change="getList()" clearable="" size="small" style="width: 150px;">
					<el-option v-for="item in statusList" :key="item.value" :value="item.value"
						:label="item.label"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="订单号">
				<el-input v-model="query.orderId" @change="getList()" clearable="" size="small"
					style="width: 150px;"></el-input>
			</el-form-item>
			<el-form-item label="收货电话">
				<el-input v-model="query.receiptPhone" @change="getList()" clearable="" size="small"
					style="width: 150px;"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="getList()" size="small" type="primary">筛选</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="changeDialog()" size="small" type="info">一键设置</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="saveMult()" size="small" type="primary">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="toggleRowSelection()" size="small">取消多选</el-button>
			</el-form-item>
		</el-form>
		<div class="flex" style="float: right;margin-top: -60px;margin-bottom: 10px;">
			<div>
				<el-button type="primary" @click="exportE()" size="small">导出</el-button>
			</div>
		</div>
		<el-table :data="list" ref="multipleTable" @selection-change="handleSelectionChange" stripe
			:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
			:cell-style="{'text-align': 'center'}" style="width: 100%" height='65vh'>
			<el-table-column type="selection" width="30" label="ID"></el-table-column>
			<el-table-column label="订单ID" width="90" prop="orderId" sortable>
			</el-table-column>
			<el-table-column label="用户名" width="100" sortable>
				<template slot-scope="{row}">
					{{row.user==null?'暂无':row.user.nickName}}
				</template>
			</el-table-column>
			<el-table-column label="用户手机号" width="110">
				<template slot-scope="{row}">
					{{row.user==null?'暂无':row.user.telphone}}
				</template>
			</el-table-column>
			<el-table-column label="产品图片" width="100px">
				<template slot-scope="{row}">
					<el-image :src="row.memberDetail.imageSmall==null?'':row.memberDetail.imageSmall"
						:preview-src-list="typeImages" @click="bigImage(row)"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="购买产品" width="100" sortable>
				<template slot-scope="{row}">
					{{row.order==null?'暂无':row.order.type}}
				</template>
			</el-table-column>
			<el-table-column label="填写的手机号" width="110" prop="receiptPhone">
				<template slot-scope="{row}">
					<div :class="row.receiptPhone!=null && row.receiptPhone.length>11? 'red':''">
						{{row.receiptPhone}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="收货人" width="110" prop="receiver"></el-table-column>
			<el-table-column label="收货地址" prop="address" width="380px">
				<template slot-scope="{row}">
					{{row.province}}{{row.city}}{{row.district}}{{row.detailAddress}}
				</template>
			</el-table-column>
			<el-table-column label="快递类型" width="130">
				<template slot-scope="{row}">
					<el-select v-if="row.edit==true" v-model="row.expressType" clearable="" size="small">
						<el-option v-for="i in expressType" :key="i.value" :value="i.value"></el-option>
					</el-select>
					<div v-else>
						{{row.expressType==null?'/':row.expressType}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="快递单号" width="160px">
				<template slot-scope="{row}">
					<el-input v-if="row.edit==true" v-model="row.express" size="small"></el-input>
					<div v-else>
						{{row.express==null?'/':row.express}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="状态" prop="status" sortable>
				<template slot-scope="{row}">
					<div v-if="row.edit==true">
						<el-select v-model="row.status" size="small" style="width: 100px;">
							<el-option v-for="i in statusList" :key="i.value" :value="i.value"
								:label="i.label"></el-option>
						</el-select>
					</div>
					<div v-else>
						<!-- {{row.status | status}} -->
						<!-- <el-tag :type="row.status | statusType">{{row.status | status}}</el-tag> -->

						<el-tag v-if="row.status == 0" type="danger">未发货</el-tag>
						<el-tag v-if="row.status == 1" type="warning">处理中</el-tag>
						<el-tag v-if="row.status == 2" type="success">已发货</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="添加时间" width="100" prop="createTime" sortable></el-table-column>
			<!-- 			<el-table-column label="修改时间" prop="updateTime" sortable>
			
			</el-table-column> -->
			<el-table-column label="操作" width="120" prop="updateTime" sortable>
				<template slot-scope="{row}">
					<div v-if="row.edit==false">
						<el-button type="text" @click="edit(row,1)">编辑</el-button>
					</div>
					<div v-else style="display: flex;padding-left: 10px;">
						<el-button type="text" @click="save(row)" style="color: red;margin-right: 5px;">保存</el-button>
						<el-button type="text" @click="edit(row,-1)">取消</el-button>
					</div>

				</template>
			</el-table-column>
		</el-table>

		<div style="text-align: center;">
			<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="[50,100, 200, 500, 9999]" style="margin-top: 30px;"
				layout="total, sizes, prev, pager, next, jumper" :current-page="query.page" :total="query.total">
			</el-pagination>
		</div>
		<el-dialog :visible.sync="changedialog" width="500px" title="更改状态">
			<div style="margin-top: -10px;">即将修改的订单id：</div>
			<div v-for="item in ids">{{item}}</div>
			状态：<el-select v-model="query.status" clearable="" @change="changeStatus()">
				<el-option v-for="item in statusList" :key="item.value" :value="item.value"
					:label="item.label"></el-option>
			</el-select>
			<div style="display: flex;margin-top: 10px;margin-left: 60%;">
				<el-button @click="changedialog=false">取消</el-button>
				<el-button type="primary" @click="change()">保存</el-button>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	import {
		url,
		isNull
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				list: [],
				url: url(),
				query: {
					page: 1,
					size: 50,
					total: 0,
					time: [],
					startTime: '',
					endTime: '',
					status: '',
					orderId: '',
					telephone: ''
				},
				queryUrl: '',
				ids: [], //多选项
				changedialog: false,
				statusList: [{
						value: 0,
						label: '未发货'
					},
					{
						value: 1,
						label: '处理中'
					},
					{
						value: 2,
						label: '已发货'
					},
				],
				expressType: [{
						value: '中通快递'
					},
					{
						value: '圆通速递'
					},
					{
						value: '顺丰速运'
					},
					{
						value: '申通快递'
					},
					{
						value: '百世快递'
					},
					{
						value: '韵达快递'
					},
					{
						value: '天天快递'
					},
					{
						value: '邮政快递'
					},
					{
						value: 'EMS'
					},
					{
						value: '宅急送'
					},
					{
						value: '德邦快递'
					},
					{
						value: '跨越速运'
					},
				],
				typeImages: []
			}
		},
		filters: {
			status(val) {
				switch (val) {
					case 0:
						return '未发货'
					case 1:
						return '处理中'
					case 2:
						return '已发货'
				}
			},
			statusType(val) {
				switch (val) {
					case 0:
						return 'danger'
					case 1:
						return 'warning'
					case 2:
						return 'success'
				}
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			queryUrl01() {
				this.queryUrl = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size
				if (this.query.time != null) {
					if (this.query.time.length > 0) {
						this.query.startTime = this.query.time[0]
						this.query.endTime = this.query.time[1]
						this.queryUrl += "&startTime=" + this.query.startTime + "&endTime=" + this.query.endTime
					}
				}
				if (this.query.status != null) {
					this.queryUrl += "&status=" + this.query.status
				}
				if (this.query.orderId != null) {
					this.queryUrl += "&id=" + this.query.orderId
				}
				if (this.query.receiptPhone != null) {
					this.queryUrl += "&telephone=" + this.query.receiptPhone
				}
			},
			getList() {
				this.queryUrl01()
				this.$http.get("activity/listReceive" + this.queryUrl).then(
					res => {
						this.list = res.body.data
						this.query.total = res.body.total
						this.createEdit()
					})
			},
			changeDialog() {
				if (this.ids.length > 0) {
					this.changedialog = true
				} else {
					this.$message.info("请选择需要修改的订单id")
				}
			},
			change(id) {
				this.$confirm('确定修改状态？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("activity/saveReceiveStatus?ids=" + this.ids + "&status=" + this.query.status)
						.then(res => {
							if (res.body.code == 200) {
								this.$message.success("保存成功")
								this.changedialog = false
								this.getList()
							} else {
								this.$message.error("保存失败")
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					})
					this.changeDialog = false
				});
			},
			changeStatus() {
				if (this.query.status == '') {
					this.query.status = 0
				}
			},
			edit(row, id) {
				if (id == -1) {
					row.edit = false //退出编辑
				} else if (id == 1) {
					row.edit = true //编辑状态
				}

			},
			save(row) {
				this.$delete(row, 'order')
				this.$delete(row, 'user')
				this.$delete(row, 'address')
				this.$delete(row, 'userId')
				this.$delete(row, 'createTime')
				this.$delete(row, 'updateTime')
				this.$http.post('activity/save', JSON.stringify(row)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.getList()
					} else {
						this.$message.error("系统异常")
					}
				})
			},
			saveMult() {
				this.list.forEach(i => {
					this.$delete(i, 'order')
					this.$delete(i, 'user')
					this.$delete(i, 'address')
					this.$delete(i, 'userId')
				})
				this.$http.post('activity/saveMult', JSON.stringify(this.list)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.getList()
					} else {
						this.$message.error("系统异常")
					}
				})
			},
			//创建edit属性
			createEdit() {
				if (!isNull(this.list) && this.list.length > 0) {
					this.list.forEach(item => {
						// let i = ''
						this.$set(item, "edit", false)
						// this.$set(item,"statusType",i)
					})
				}
			},
			//删除edit属性
			cleanEdit() {
				this.list.forEach(i => {
					this.$delete(i, 'edit')
				})
			},
			bigImage(row) {
				this.typeImages = []
				this.typeImages.push(row.memberDetail.imageSmall)
			},
			handleSelectionChange(val) {
				this.ids = []
				const idsArray = val
				if (idsArray != null) {
					if (idsArray.length > 0) {
						idsArray.forEach(item => {
							this.ids.push(item.orderId)
						})
					}
				}
				// 默认为非编辑状态
				this.list.forEach(i => {
					i.edit = false
				})
				// 选择的行设置为编辑状态
				val.forEach(i => {
					i.edit = true
				})
			},
			toggleRowSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			exportE() {
				this.queryUrl01()
				window.location.assign(this.url + "activity/export" + this.queryUrl)
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getList()
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.flex {
		display: flex;
	}

	.red {
		color: red;
	}
</style>